import {
  ActionIcon,
  Button,
  Group,
  Menu,
  useMantineTheme,
} from "@mantine/core";
import { Link, getRouteApi } from "@tanstack/react-router";
import { IconMenu2 } from "@tabler/icons-react";
import { useAuthLayout } from "../context";
import classes from "./LandingNav.module.css";
import { useNavigation } from "@/hooks/useNavigation";
import { ButtonLink } from "@/components/navigation";

const indexRouteApi = getRouteApi("/");

const navItems = [
  {
    hash: "how-it-works",
    label: "How it works",
  },
  {
    hash: "project-categories",
    label: "Project types",
  },
  {
    hash: "features",
    label: "Features",
  },
] as const;

export function LandingNav() {
  const { handleRegisterClick } = useNavigation();
  const { isAuthenticated, isMobile } = useAuthLayout();
  const theme = useMantineTheme();

  if (isMobile) {
    return (
      <Group wrap="nowrap" className={classes.headerNavMobile} gap="xs">
        {/* CTA button for non-authed users */}
        {!isAuthenticated && (
          <Button
            size="sm"
            radius="md"
            variant="gradient"
            gradient={{ from: "indigo", to: "cyan", deg: 45 }}
            className={classes.ctaButton}
            onClick={handleRegisterClick}
          >
            Start&nbsp;Free
          </Button>
        )}

        {/* Burger / menu */}
        <Menu width={180} position="bottom-end" withinPortal>
          <Menu.Target>
            <ActionIcon
              variant="subtle"
              size="lg"
              aria-label="Open navigation menu"
            >
              <IconMenu2 size={24} />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            {navItems.map(({ hash, label }) => (
              <Menu.Item
                key={label}
                component={indexRouteApi.Link}
                to="/"
                hash={hash}
              >
                {label}
              </Menu.Item>
            ))}
            {isAuthenticated ? (
              <Menu.Item component={Link} to="/dashboard">
                Dashboard
              </Menu.Item>
            ) : null}
          </Menu.Dropdown>
        </Menu>
      </Group>
    );
  }

  // Desktop navigation
  return (
    <Group wrap="nowrap" gap="lg" justify="flex-end" align="center">
      {navItems.map(({ hash, label }) => (
        <indexRouteApi.Link
          key={label}
          to="/"
          hash={hash}
          style={{
            textDecoration: "none",
            color: "inherit",
            fontSize: theme.fontSizes.lg,
            fontWeight: 600,
          }}
        >
          {label}
        </indexRouteApi.Link>
      ))}

      {isAuthenticated ? (
        <ButtonLink to="/dashboard" size="sm" visibleFrom="md">
          Dashboard
        </ButtonLink>
      ) : (
        <Button
          size="sm"
          onClick={handleRegisterClick}
          className={classes.button}
          visibleFrom="md"
        >
          Get&nbsp;Started
        </Button>
      )}
    </Group>
  );
}
